<script>
import Inputmask from "inputmask";

const $date = (stringdate) => {
  if (!stringdate) return null;
  const date = new Date(stringdate);
  if (!isValidDate(date)) return null;
  const year = date.getFullYear();
  const month = (date.getMonth() + 1).toString().padStart(2, "0");
  const day = date.getDate().toString().padStart(2, "0");
  return `${day}.${month}.${year}`;
};

function isValidDate(d) {
  if (d instanceof Date && !isNaN(d)) {
    const year = d.getFullYear();
    return year > 1;
  } else return false;
}

export default {
  props: {
    required: Boolean,
    clearable: Boolean,
    value: String,
    label: String,
    dense: {
      type: Boolean,
      default: () => true,
    },
    hideDetails: {
      type: Boolean,
      default: () => true,
    },
    autofocus: Boolean,
    readonly: Boolean,
    minValue: {
      type: String,
      default: () => undefined,
    },
    maxValue: {
      type: String,
      default: () => undefined,
    },
  },

  data: (vm) => ({
    modelValue: null,
    modelPicker: null,

    isValid: true,

    isShowPicker: false,

    dateRule: (v) => {
      const str = `${v || ""}`.replaceAll("-", "");
      return vm.$number(str) > 0 || "";
    },
  }),

  created() {
    this.onInitValue();
  },

  watch: {
    value() {
      this.onInitValue();
    },

    modelPicker() {
      this.onInitValue({ isPicker: true });
      this.isShowPicker = false;
    },
  },

  computed: {
    maxValuePicker() {
      const isValid = Inputmask.isValid(this.maxValue, {
        alias: "datetime",
        inputFormat: "dd-mm-yyyy",
      });

      if (isValid) {
        return Inputmask.unmask(this.maxValue, {
          alias: "datetime",
          inputFormat: "dd-mm-yyyy",
          outputFormat: "yyyy-mm-dd",
        });
      }
      return undefined;
    },

    minValuePicker() {
      const isValid = Inputmask.isValid(this.minValue, {
        alias: "datetime",
        inputFormat: "dd-mm-yyyy",
      });

      if (isValid) {
        return Inputmask.unmask(this.minValue, {
          alias: "datetime",
          inputFormat: "dd-mm-yyyy",
          outputFormat: "yyyy-mm-dd",
        });
      }
      return undefined;
    },
  },

  methods: {
    onInitValue(payload) {
      const { isPicker } = payload || {};
      let valueStr = isPicker ? this.modelPicker : this.value;
      valueStr = `${valueStr || ""}`.replace(/ /g, "");
      if (valueStr == "") return;

      const date = $date(valueStr);
      if (date) {
        valueStr = date;
      } else {
        const isValid = Inputmask.isValid(valueStr, {
          alias: "datetime",
          inputFormat: "dd.mm.yyyy",
        });

        if (!isValid) {
          const isValidDate = Inputmask.isValid(valueStr, {
            alias: "datetime",
            inputFormat: "yyyy-mm-dd",
          });

          if (isValidDate) {
            valueStr = Inputmask.unmask(valueStr, {
              alias: "datetime",
              inputFormat: "yyyy-mm-dd",
              outputFormat: "dd.mm.yyyy",
            });
          }

          const isValidInput = Inputmask.isValid(valueStr, {
            alias: "datetime",
            inputFormat: "dd.mm.yyyy",
          });

          if (!isValidInput) valueStr = "";
        }
      }

      this.modelValue = valueStr?.length ? valueStr : null;
      this.$nextTick(() => this.onBlur({ init: !isPicker }));
    },

    onBlur(event) {
      if (this.readonly) return;

      let modelValue = `${this.modelValue || ""}`;

      const isDot = Inputmask.isValid(modelValue, {
        alias: "datetime",
        inputFormat: "dd.mm.yyyy",
      });

      if (isDot) {
        modelValue = this.modelValue = Inputmask.unmask(modelValue, {
          alias: "datetime",
          inputFormat: "dd.mm.yyyy",
          outputFormat: "yyyy-mm-dd",
        });
      }

      this.isValid = Inputmask.isValid(modelValue, {
        alias: "datetime",
        inputFormat: "yyyy-mm-dd",
      });

      const valueStr = this.isValid ? modelValue.replace(/ /, "") : "";
      const inputValue = valueStr.length ? valueStr : undefined;
      if (!event.init) this.$emit("input", inputValue);
      else this.modelPicker = inputValue;

      if (event?.key == "enter") {
        this.$emit("enterKey");
      } else if (event?.key == "tab") {
        this.$emit("tabKey");
      }
    },

    onClear() {
      this.modelPicker = null;
    },

    onShowPicker() {
      this.onBlur({ init: true });
      this.$nextTick(() => (this.isShowPicker = true));
    },

    focus() {
      this.$refs.input.focus();
    },
  },
};
</script>

<template>
  <v-text-field
    ref="input"
    :label="label"
    v-inputmask="$masks.date_max({ min: minValue, max: maxValue })"
    @blur="onBlur"
    :error="!isValid"
    @keyup.enter="onBlur({ key: 'enter' })"
    @input="isValid = true"
    @focus="isValid = true"
    v-model="modelValue"
    :rules="required ? [dateRule] : []"
    :autofocus="autofocus"
    :dense="dense"
    :clearable="clearable"
    :hide-details="hideDetails"
    @click:clear="onClear"
    outlined
    :readonly="readonly"
  >
    <template #append>
      <v-menu
        v-model="isShowPicker"
        :close-on-content-click="false"
        offset-z
        nudge-left="254"
        nudge-top="10"
      >
        <template #activator="{}">
          <v-icon @click="onShowPicker"> mdi-calendar-blank </v-icon>
        </template>

        <v-date-picker
          :max="maxValuePicker"
          :min="minValuePicker"
          v-model="modelPicker"
          first-day-of-week="1"
        />
      </v-menu>
    </template>
  </v-text-field>
</template>
